import { Paginated as LocalPaginated } from "@/pagination";
import { WithTimestamps } from "@/typing";
import HttpService from "./http-service";
import { AsyncPaginatedRequest } from "./";
import { LazyAsyncIter } from "@/iterators";
import { SnakeCasedProperties } from "type-fest";
import EntityDocumentation from "@/entities/entity-documentation";
import { pageMapperBuilder } from "@/pagination/paginated";
import { RequireExactlyOne } from "type-fest";
export default class EntityDocumentationService extends HttpService {
  public getEntityDocumentations(
    entityId: number,
    documentationIds?: number[]
  ): LazyAsyncIter<LocalPaginated<EntityDocumentation>> {
    const params = {
      documentation_ids: documentationIds?.join(","),
    };
    const asyncIter = new AsyncPaginatedRequest<EntityDocumentationDTO>(
      "get",
      `/entities/${entityId}/documentations`,
      params,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();
    return new LazyAsyncIter(asyncIter).map(
      pageMapperBuilder(entityDocumentationFromDTO)
    );
  }

  public async getEntityDocumentation(
    params: GetEntityDocumentationParams
  ): Promise<EntityDocumentation> {
    const url = params.entityDocIds
      ? `/entities/${params.entityDocIds.entityId}/documentations/${params.entityDocIds.documentaitonId}`
      : `/entity-documentations/${params.entityDocId}`;

    const response = await this.httpClient.get<EntityDocumentationDTO>(url);
    return entityDocumentationFromDTO(response.data);
  }

  public async getBackingEntityDocumentation(
    entityDocId: number
  ): Promise<EntityDocumentation | null> {
    const { data } = await this.httpClient.get<EntityDocumentationDTO | null>(
      `/entity-documentations/${entityDocId}/backing`
    );

    return data === null ? data : entityDocumentationFromDTO(data);
  }
}

export type GetEntityDocumentationParams = RequireExactlyOne<{
  entityDocId: number;
  entityDocIds: {
    entityId: number;
    documentaitonId: number;
  };
}>;

type EntityDocumentationDTO = SnakeCasedProperties<
  Omit<EntityDocumentation, "createdAt" | "updatedAt"> & WithTimestamps
>;

function entityDocumentationFromDTO(
  dto: EntityDocumentationDTO
): EntityDocumentation {
  return {
    id: dto.id,
    entityId: dto.entity_id,
    documentationId: dto.documentation_id,
    createdAt: new Date(Date.parse(dto.created_at)),
    updatedAt: new Date(Date.parse(dto.updated_at)),
  };
}

export interface Entity {
  id: number;
  name: string;
  acronym: string;
  entity_type_id: number;
}
